import { inject } from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import { AuthService } from '../auth.service';
import { Permission } from '../models/permission.enum';

export const administrationGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if(!authService.hasPermission(Permission.CanAccessUserManagement))
  {
    router.navigate(['/access-denied']);
    return false;
  }

  return true;
};

export const announcementManagementGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.hasPermission(Permission.CanAccessAnnouncementManagement)) {
    router.navigate(['/access-denied']);
    return false;
  }

  return true;
};
